export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-paint-bucket-490538ea11686addc75f294fee8410e7.svg";